<template>
  <div id="GenRedOne">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'GenRedOne'
}
</script>

<style scoped>
#GenRedOne {
   width:100%;
  height:100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/GenRedOne/GenRedOne.vue